
  import { Component, Prop, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';
  import moment from 'moment';

  import InputDate from '@/components/Core/InputDate.vue';
  import accountService from '@/services/account.service';
  import tokenService from '@/services/token.service';
  import { IErrorModel } from '@/models/errors.model';
  import { ILoginModel } from '@/models/login.model';
  import { IRequestResultModel } from '@/models/request.model';

  @Component({
    components: {
      InputDate
    },
    computed: {
      ...mapGetters([
        'isLoading'
      ])
    }
  })
  export default class AgeVerification extends Vue {
    @Prop({ type: Object as () => ILoginModel })
    public user!: ILoginModel;

    public data() {
      return {
        isDateOfBirthLoading: false,
        dateOfBirth: undefined,
        hasErrors: false,
        errors: new Array<IErrorModel>(),
        minimumAge: undefined,
        birthdateCondition: "",
        privacyPolicyLink: "",
        cookiesPolicyLink: "",
        dateOfBirthSaved: false,
      }
    };

    public created(): void {
      this.initPrivacyLinks();
      
      this.$data.minimumAge = this.$store.getters.ageGateSettings.LowThresholdAge;
      this.$data.birthdateCondition = `To login, you need to be at least ${this.$data.minimumAge}.`;

      window.addEventListener('beforeunload', () => {
        if (!this.$data.dateOfBirthSaved) {
          this.$cookies.remove("_g2g_identity_");
        }
      })
    }

    public mounted(): void {
      this.$watch(() => this.$store.getters.privacyLinks, (params) => {
        this.initPrivacyLinks();
      });
    }

    public confirmDateOfBirth(): void {
      this.$store.dispatch("updateIsLoading", true);
      this.$data.isDateOfBirthLoading = true;
      this.$data.hasErrors = false;
      this.$data.errors = new Array<IErrorModel>();

      if ((this.$refs.inputDateRef as InputDate).hasBadDateInput()) {
        this.$data.hasErrors = true;
        this.$data.errors.push({ Property: "Date", ErrorMessage: "ERROR_INCOMPLETE_MANDATORY_FIELD" } as IErrorModel);
      }

      if (this.$data.errors.length > 0) {
        this.$store.dispatch("updateIsLoading", false);
        this.$data.isDateOfBirthLoading = false;
        return;
      }

      const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "log/user/" + this.user.Id_User + "/set-date-of-birth";
      const longDelay: number = this.$store.getters.ageGateSettings.DaysBeforeDeleteLongDelay;
      const token = this.$cookies.get("_g2g_identity_");

      if (!token) {
        this.$emit('update:view', 'LoginHome');
      }

      accountService.post<Object, IRequestResultModel>(this, url, { DateOfBirth: this.$data.dateOfBirth }, { headers: { Authorization: "Bearer " + token } })
        .then(response => {
          if (response.Success) {
            this.$data.dateOfBirthSaved = true;

            if (this.$data.dateOfBirth && moment(this.$data.dateOfBirth).add(this.$data.minimumAge, 'year').isAfter(moment())) {
              this.$cookies.remove("_g2g_identity_");
              
              const willReachMinimumAgeWithinYear = moment(this.$data.dateOfBirth).add(this.$data.minimumAge, 'year').isSameOrBefore(moment().add(longDelay, 'day'));
              this.$emit('update:lowThresholdAgeGateBirthdaySoon', willReachMinimumAgeWithinYear);
              
              this.$store.dispatch("updateIsLoading", false);
              this.$data.isDateOfBirthLoading = false;
              this.$emit('update:view', 'AccessRestricted');
            } 

            this.$data.isDateOfBirthLoading = false;
            tokenService.setToken(this, true);
          } else {
            this.$store.dispatch("updateIsLoading", false);
            this.$data.isDateOfBirthLoading = false;
          }
        })
        .catch(error => {
          this.$store.dispatch("updateIsLoading", false);
          this.$data.isDateOfBirthLoading = false;
          this.$data.errors = error.data.ErrorMessages;
        })
    }

    public updateDateOfBirthValue(parameterName: string, value: Date): void {
      this.$data.dateOfBirth = value;
    }

    private initPrivacyLinks(): void {
      this.$data.privacyPolicyLink = this.$store.getters.privacyLinks.PrivacyPolicy;
      this.$data.cookiesPolicyLink = this.$store.getters.privacyLinks.CookiePolicy;
    }
  }
